<template>
  <div class="job-info">
    <div class="job-info-line">
      <span v-if="job.hot" class="hot-job-icon custom-font-color"></span>
      <div class="job-title custom-font-color" :title="job.title">{{ job.title }}</div>
      <div class="job-release-date">{{ job.updated_time }}</div>
    </div>
    <div class="job-info-line">
      <div class="job-exrta-info">
        <span class="job-salary">{{ job.salary }}</span>
        <span class="slash">/</span>
        <span class="job-role-type">{{ job.role_type }}</span>
        <span class="slash">/</span>
        <span class="job-work-time">{{ job.work_time }}</span>
      </div>
      <div class="job-location">
        <template v-if="job.locations && job.locations.length > 0">
          <span class="first-location">{{ job.locations[0].address }}</span>
          <span v-if="job.locations.length > 1" class="more-location">
            <span>{{ $t('microSite.jobList.location.prefix') }}</span>
            <span class="location-count custom-font-color">{{ job.locations.length }}</span>
            <span>{{ $t('microSite.jobList.location.suffix') }}</span>
          </span>
          <div class="location-list-container">

          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    job: {
      type: Object,
      required: true
    }
  },
  data () {
    return {

    }
  },
  computed: {

  },
  created () {

  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.job-info {
  background: #F4F4F4;
  margin-top: 10px;
  padding: 10px 20px 20px;
  cursor: pointer;

  .job-info-line {
    display: flex;
    position: relative;

    & + .job-info-line {
      margin-top: 8px;
    }

    .job-title {
      flex: 1;
      font-size: 20px;
      color: #409EFF;
      overflow: hidden;
      white-space: nowrap;
      word-break: keep-all;
      text-overflow: ellipsis;
    }

    .hot-job-icon {
      font-family: 'icomoon' !important;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      font-style: normal;
      font-weight: 400;
      font-size: 24px;
      font-variant: normal;
      text-transform: none;
      line-height: 1;
      color: #409EFF;
      position: absolute;
      left: -21px;
      bottom: 2px;

      &::before {
        content: "\e91e";
      }
    }

    .job-release-date {
      font-size: 14px;
      color: #666666;
      align-self: flex-end;
    }

    .job-exrta-info {
      font-size: 14px;
      color: #333333;

      .slash {
        margin: 0 5px;
      }
    }

    .job-location {
      flex: 1;
      text-align: right;
      position: relative;
      font-size: 14px;
      color: #333333;

      .first-location {

      }

      .more-location {
        margin-left: 10px;

        .location-count {
          color: #419dfe;
        }
      }

      .location-list-container {
        display: none;
        position: absolute;
      }
    }
  }
}
</style>
